import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { FormControl, FormGroup } from '@angular/forms';
import { GalleriaSpettacolo, Spettacolo } from '../../../../shared/interface';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { Table } from 'primeng/table';
import { ImagePipe } from '../../../../shared/image.pipe';

@Component({
  selector: 'app-galleria-spettacolo-backoffice',
  templateUrl: './galleria-spettacolo-backoffice.component.html',
  styleUrl: './galleria-spettacolo-backoffice.component.css'
})
export class GalleriaSpettacoloBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef, private imagePipe: ImagePipe) {}
    
  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;

  @Input() spettacolo?: Spettacolo;
  @Input() galleria: GalleriaSpettacolo[] = [];
  @Output() data = new EventEmitter<{galleria: GalleriaSpettacolo[], files: File[]}>();
    
  files: File[] = [];
  file?: GalleriaSpettacolo;  

  add: boolean = false;
  add_image: boolean = false;
  add_files: boolean = false;
  edit: boolean = false;

  immagine: string = '';

  formGalleria!: FormGroup;  

  ngOnInit(): void {

    addEventListener("mousemove", (event) => {
      let bubble = document.getElementById('bubble');
      if (bubble) {
        let y = event.pageY;
        let x = event.pageX;
        bubble.style.top = y + 'px';
        bubble.style.left = x + 'px';
      }
    });

    this.formGalleria = new FormGroup({
      evidenza: new FormControl(null),
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onUpload(event: FileSelectEvent) {
    event.currentFiles.map(file => this.files.push(file))    
  }

  onRemoveUpload(event: FileRemoveEvent) {
    this.files = this.files.filter(file => event.file != file);
  }

  onClearUpload(event: any) {
    this.files = [];
  }

  onAddFilesGalleria(files: File[]) {

    files.map(file => {

      this.galleria.push({
        id: 0,
        file: file.name,
        type: file.type == 'image/png' ? 'image' : 'video',
        posizione: 999,
        evidenza: false,
        id_spettacolo: +this.spettacolo!.id,
        data_creazione: new Date(),
        data_aggiornamento: new Date(),
        file_upload: file
      })

    })
    
    this.data.emit({galleria: this.galleria, files: files});

    this.add = false;
    this.add_files = false;
  }

  onAddFileGalleria(file: string) {

    this.galleria.push({
      id: 0,
      file: 'ImgGalleriaRitagliata_' + this.galleria.filter(file => file.file_base64).length + '.jpg',
      type: 'image',
      posizione: 999,
      evidenza: false,
      id_spettacolo: +this.spettacolo!.id,
      data_creazione: new Date(),
      data_aggiornamento: new Date(),
      file_base64: file
    })

    this.data.emit({galleria: this.galleria, files: this.files});    

    this.immagine = '';
    this.add = false;
    this.add_image = false;
  }

  onRemoveFileGalleria(file: GalleriaSpettacolo) {
    this.files = this.files.filter(file_upload => file_upload != file.file_upload);
    this.galleria = this.galleria.filter(file_galleria => file_galleria.file != file.file)
  }

  onOpenEdit(file: GalleriaSpettacolo) {
    this.file = file;
    this.formGalleria.setValue({ evidenza: file.evidenza ? ['evidenza'] : [] })
    this.edit = true;
  }

  onEdit() {
    this.galleria.filter(file => file == this.file).map(file => {
      file.evidenza = this.formGalleria.get('evidenza')?.value ? (this.formGalleria.get('evidenza')?.value.length > 0 ? true : false) : false;
      return file;      
    });
    this.onCloseModal();
  }

  onOpenDelete(event: Event, file: GalleriaSpettacolo, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il file della galleria?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteGalleriaSpettacolo(file.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.galleria.splice(index, 1)
            this.apiService.message("success", "Eliminazione", "Il file della galleria è stato eliminato con successo")
            this.cdr.detectChanges();
          }
        })
      }
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onAnnullaDelete() {
    this.delete.reject();
  }

  setBubbleImage(file: GalleriaSpettacolo) {
    if (!file.file_base64 && file.type == 'image' && file.id !== 0) {
      let bubble = document.getElementById('bubble');
      bubble!.style.backgroundImage = 'url("' + (this.imagePipe.transform(file.file + '?type=spettacolo'))  + '")';
      bubble!.style.width = '200px';
      bubble!.style.height = '200px';
    }
  }

  deleteBubbleImage(file: GalleriaSpettacolo) {
    if (!file.file_base64 && file.type == 'image') {
      let bubble = document.getElementById('bubble');
      bubble!.style.width = '0px';
      bubble!.style.height = '0px';
    }
  }

  onCloseModal() {    
    this.add = false;
    this.add_files = false;
    this.add_image = false;
    this.edit = false;
    this.files = [];
  }

}
